<ng-container *ngIf="!isSiteIntl; else fundDetail">
  <span>{{ "literature.audience_" + audience | translate }}</span>
  <ng-container *ngIf="!isInvestor">
    <ng-container *ngIf="params?.data?.literatureData?.href">
      <div>
        <eds-link-item
          title="{{ 'literature.finra-letter' | translate }}"
          [useSmallText]="true"
          [hasIcon]="true"
          type="new-window"
          [hasTarget]="false"
          size="small"
          (click)="goToLink(params?.data?.literatureData, $event)"
        ></eds-link-item>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #fundDetail>
  {{ cellvalue }}
</ng-template>
